import { DateTime } from 'luxon';
import { Calendarevent } from 'data/firestore/agent/calendarevent/types';

const getDayKey = (date: Date, timeZone: string) => DateTime
    .fromJSDate(date)
    .setZone(timeZone)
    .toFormat('yyyy-LL-dd');

const groupEventsByDay = ({
    events,
    days,
    timeZone,
}: {
    events: Calendarevent[];
    days: Date[];
    timeZone: string;
}) => {
    const eventsByDay = days.reduce<Record<string, Calendarevent[]>>((acc, day) => {
        acc[getDayKey(day, timeZone)] = [];
        return acc;
    }, {});

    events.forEach((event) => {
        const key = getDayKey(event.startAt, timeZone);
        if (eventsByDay[key]) {
            eventsByDay[key].push(event);
        }
    });

    return days.map((day) => ({
        day,
        events: eventsByDay[getDayKey(day, timeZone)],
    }));
};

export default groupEventsByDay;
